module.exports = __webpack_public_path__ + "static/media/main_visual_compact_track_loaders_1350_rt_manitou (1).43fd45fa.png";